import { cn } from "../../helpers"

const intercom = (className?: string) =>
  cn(
    "absolute bottom-[calc(100%+20px)] right-5 flex h-16 w-16 cursor-pointer items-center justify-center rounded-full bg-indigo-700 fill-white",
    className,
  )

export { intercom }
